import axios from 'axios';
import qs from 'qs';
// import { handleLogout } from '../auth/logout';


const getBaseURL = () => {
  const teamscheck = localStorage.getItem('inTeams') === 'true';
  const customDomain = localStorage.getItem('custom_domain');
  if (teamscheck && customDomain) {
    const cleanDomain = customDomain.replace(/^https?:\/\//, '').replace(/\/$/, '');
    return `https://${cleanDomain}/api`;
  }
  return `${window.location.origin}/api`;
};

const baseapi = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});

baseapi.interceptors.request.use(
  (config) => {
    config.baseURL = getBaseURL();
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

baseapi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // handleLogout();
      console.log("401 Unauthorized");
    }
    return Promise.reject(error);
  }
);

export default baseapi;
